<template>
<div>
    <RepairListTable  />
    <v-content>
        <v-btn fab bottom right color="pink" dark fixed @click="cardOpen()">
            <v-icon>add</v-icon>
        </v-btn>
    </v-content>
    <NewRepairCard />
</div>
</template>

<script>
import {
    HTTP
} from '../http-common'


import NewRepairCard from './NewRepairCard.vue'
import RepairListTable from './RepairListTable.vue'

export default {
    components: {
        NewRepairCard,
        RepairListTable
    },
    data: () => ({
        error: [],
        status: 0
    }),
    props: {},
    methods: {
        cardOpen() {
            this.$store.commit('openCloseCard', !this.$store.state.main.cardOpened);
        },

    },
    watch: {
        '$route.query.query'() {
            this.$root.$emit('reloadRepairTable')
        },
        '$route.query.status'() {
            this.$root.$emit('reloadRepairTable')
        }

    },
    computed: {
        cardStatus() {
            if (this.$route.name == 'home' && this.$route.query && this.$route.query.status) {
                if (this.status != Number(this.$route.query.status)) {
                    this.status = Number(this.$route.query.status)
                    this.$root.$emit('reloadRepairTable', this.status)
                }
            }
            if (this.$route.name == 'home' && !(this.$route.query && this.$route.query.status)) {
                if (this.status > 0) {
                    this.status = 0
                    this.$root.$emit('reloadRepairTable', this.status)
                }
            }
            return this.status
        }
    },
    created() {

    }
}
</script>
